import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  // Set 404 status for crawlers/bots
  useEffect(() => {
    // This doesn't actually set HTTP status in client-side routing,
    // but helps with semantic meaning
    document.title = '404 - Page Not Found | Raven Environmental';
    
    // Client-side redirect for specific legacy URLs
    // This handles the redirect immediately if Cloudflare page rules don't catch it
    const path = window.location.pathname;
    if (path === '/military') {
      window.location.replace('/permit-feasibility');
    } else if (path === '/what-we-do-bedford') {
      window.location.replace('/services');
    } else if (path === '/contact/soil-remediation') {
      window.location.replace('/permit-applications');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300">404</h1>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4 mb-4">
            Page Not Found
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-emerald-600 text-white rounded-lg font-semibold hover:bg-emerald-700 transition-colors"
          >
            <Home className="mr-2" size={20} />
            Go to Homepage
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
          >
            <ArrowLeft className="mr-2" size={20} />
            Go Back
          </button>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-600 mb-4">Looking for something specific?</p>
          <div className="flex flex-wrap gap-2 justify-center">
            <Link to="/services" className="text-emerald-600 hover:text-emerald-700 font-medium">
              Services
            </Link>
            <span className="text-gray-400">•</span>
            <Link to="/industries" className="text-emerald-600 hover:text-emerald-700 font-medium">
              Industries
            </Link>
            <span className="text-gray-400">•</span>
            <Link to="/contact" className="text-emerald-600 hover:text-emerald-700 font-medium">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
